<template>
  <label for="" class="text-white text-base">
    Select Collateral
  </label>
  <div
    class="flex flex-col items-start w-full bg-block-5 border border-block-2 rounded-md"
  >
    <button
      class="flex items-center justify-between w-full p-3"
      @click="onShowOptions"
    >
      <div class="flex items-center gap-3 text-white">
        <img
          :src="modelValue.token.img"
          alt=""
          class="h-8 w-8 rounded-full"
        />
        <span class="text-base font-medium">
          {{ modelValue.token.name }}
          <span class="text-sm">({{ modelValue.token.symbol }})</span>
        </span>
      </div>
      <img
        src="/svg/caret.svg"
        :class="{
          'transform rotate-180': showOptions,
        }"
      />
    </button>
    <div v-if="showOptions" class="flex flex-col w-full gap-2">
      <div class="px-3 w-full">
        <InputIcon placeholder="Search Token" v-model="search" />
      </div>
      <div class="flex flex-col text-white w-full">
        <div
          class="flex items-center justify-between text-white font-semibold px-3 text-base"
        >
          <h1>Collateral</h1>
          <h1>Balance</h1>
        </div>
        <div
          v-if="filteredLoanCollateral.length > 0"
          class="flex flex-col h-full max-h-72 overflow-y-auto scrollbar scrollbar-thumb-gray-1 scrollbar-track-transparent scrollbar-thin mt-2"
        >
          <CollateralSelectButton
            v-for="(collateral, index) in filteredLoanCollateral"
            :key="index"
            :collateral="collateral"
            :is-selected="
              modelValue &&
              modelValue.pool.toLowerCase() ==
                collateral.pool.toLowerCase()
            "
            @select="onSelectCollateral"
          />
        </div>
        <Empty
          v-else
          title="No collateral token found!"
          compact
          plain
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CollateralSelectButton from "./CollateralSelectButton.vue";
import InputIcon from "../global/InputIcon.vue";
import Empty from "../global/Empty.vue";

export default {
  name: "HypeSelect",

  components: {
    CollateralSelectButton,
    InputIcon,
    Empty,
  },

  props: {
    modelValue: { type: Object },
    label: { type: String },
    placeholder: { type: String },
  },

  emits: ["update:modelValue"],

  data() {
    return {
      filteredLoanCollateral: [],
      showOptions: false,
    };
  },

  computed: {
    ...mapGetters(["loanCollateralTokens"]),

    valueMutable: {
      get() {
        return this.modelValue.pool;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },

    search: {
      get() {
        return null;
      },
      set(val) {
        if (val) {
          const searchResults = this.loanCollateralTokens.filter(
            (obj) => {
              const objectName = obj.token.name.toLowerCase();
              const objectSymbol = obj.token.symbol.toLowerCase();
              const term = val && val.toLowerCase();

              for (let i = 0; i < term.length; i++) {
                if (
                  objectName[i] !== term[i] ||
                  objectSymbol[i] !== term[i]
                ) {
                  return false;
                }
              }
              return true;
            }
          );
          this.filteredLoanCollateral = searchResults;
        } else {
          this.filteredLoanCollateral = this.loanCollateralTokens;
        }
      },
    },
  },

  methods: {
    onSelectCollateral(collateral) {
      this.valueMutable = collateral.pool;
      this.showOptions = false;
      this.search = null;
    },

    onShowOptions() {
      this.showOptions = !this.showOptions;
      this.search = null;
    },
  },

  mounted() {
    this.filteredLoanCollateral = this.loanCollateralTokens;
  },
};
</script>
